
import { useState, useRef } from "react";
import { BsHeart } from "react-icons/bs";
import { Tooltip } from "@chakra-ui/react";
import { Skeleton, SkeletonCircle, SkeletonText } from "@chakra-ui/react";
import {
    Flex,
    Circle,
    Box,
    Image,
    Badge,
    useColorModeValue,
    Icon,
    chakra,
    Text,
    FormControl,
    FormLabel,
    Switch,
    Button,
  } from "@chakra-ui/react";

function SkeletonTrack({
  }) {
    const [hover, sethover] = useState(false);
    const [orders, setorders] = useState([]);
  
    return (
      <Flex
       mb={'30px'}
        w="100%"
        //   w="full"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          w="100%"
          maxW="sm"
          borderWidth="1px"
          rounded="lg"
          shadow="lg"
          position="relative"
        >
          <Flex position="relative" class="image-wrapper profile-pic">
            
            <Skeleton
              top="0px"
              h="370px"
              w="100%"
              objectFit={"cover"}
              transition="opacity 0.5s ease-in-out"
              alt="normal"
            />
          </Flex>
  
          <Box p="6">
            <SkeletonText
              textAlign={"left"}
              fontSize="xl"
              fontWeight="semibold"
              as="h4"
              lineHeight="tight"
              isTruncated
            >
             
            </SkeletonText>
            
            <Box mt="35px" textAlign={"left"}>
              <SkeletonText mt="1"></SkeletonText>
              <SkeletonText mt="30px"></SkeletonText>
            </Box>
  
            
          </Box>
        </Box>
      </Flex>
    );
  }

export { SkeletonTrack };
